import { render } from "./contactUs.vue?vue&type=template&id=66906004&scoped=true"
import script from "./contactUs.vue?vue&type=script&lang=js"
export * from "./contactUs.vue?vue&type=script&lang=js"

import "./contactUs.vue?vue&type=style&index=0&id=66906004&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66906004"],['__file',"src/components/contactUs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "66906004"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('66906004', __exports__)) {
    api.reload('66906004', __exports__)
  }
  
  module.hot.accept("./contactUs.vue?vue&type=template&id=66906004&scoped=true", () => {
    api.rerender('66906004', render)
  })

}


export default __exports__